module.exports = __webpack_public_path__ + "static/passport_vklada_anything_goes-92416913b9e092989dff67d02b19fdfa.pdf";